/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Добавить заявку в ПЛ.
 */
export interface LoyaltyRequestDtoAdd { 
    /**
     * название любимого места.
     */
    name: string;
    /**
     * город и местоположение места.
     */
    location: string;
    /**
     * ссылка на карту.
     */
    mapLink?: string;
    /**
     * ссылки на сайт или соцсети.
     */
    webLink?: string;
    /**
     * почему хочет скидку.
     */
    reasonText?: string;
    /**
     * готов рассказать о PremiumCode.
     */
    readyToPromote?: boolean;
    /**
     * контакты для связи.
     */
    userContactsText?: string;
    /**
     * Контакт директора или менеджера, если известен
     */
    managerContact?: string;
}

